import type { FeatureFlagQuickActions } from './feature-flags.interfaces';

export const QUICK_ACTIONS_DEFAULT = {
  copy: true,
  export: {
    docx: false,
  },
  starsAi: {
    changeTone: {
      casual: true,
      professional: true,
      straightforward: true,
    },
    improveWriting: {
      enhanceVocabulary: true,
      simplifyLanguage: true,
    },
    makeLonger: false,
    makeShorter: true,
    translate: {
      english: true,
      french: true,
      spanish: true,
    },
  },
  thumbsDown: false,
  thumbsUp: false,
} satisfies FeatureFlagQuickActions;
